import React from 'react';

export const StatusBadge = ({ type, value, statusId, catalog, className = '' }) => {
    // Support legacy prop usage temporarily or if needed, but prioritize type/value
    let displayValue = value;

    // If using statusId/catalog (Legacy/Current implementation in Trademarks.js)
    // BUT only if value is not provided
    if (statusId && catalog && !value) {
        const statusObj = catalog.find(s => s.id === statusId);
        displayValue = statusObj ? statusObj.status_name : statusId;
    }

    // P0 UX: Empty states handling (NO DASHES)
    if (!displayValue || displayValue === '—') {
        // IMPI: If empty, render NOTHING (placeholder '—' is banned)
        if (type === 'impi') return null;

        // Legal: If empty, render specific text
        if (type === 'legal') {
            return (
                <span className={`text-xs text-gray-400 italic ${className}`}>
                    Sin estatus legal
                </span>
            );
        }

        // Default/Legacy: Render nothing instead of dash to be safe
        return null;
    }

    const lowerValue = String(displayValue).toLowerCase();
    let colorClass = 'bg-gray-100 text-gray-700';

    // Logic based on TYPE
    if (type === 'impi') {
        // Official IMPI Status logic
        if (lowerValue.includes('vigente')) {
            colorClass = 'bg-green-100 text-green-800 border border-green-200';
        } else if (lowerValue.includes('vencida') || lowerValue.includes('caduc') || lowerValue.includes('cancelad')) {
            colorClass = 'bg-red-100 text-red-800 border border-red-200';
        } else if (lowerValue.includes('tramite') || lowerValue.includes('examen') || lowerValue.includes('fondo') || lowerValue.includes('forma')) {
            colorClass = 'bg-blue-100 text-blue-800 border border-blue-200';
        } else {
            colorClass = 'bg-gray-100 text-gray-800 border border-gray-200';
        }
    } else {
        // Legal/Internal Status logic (default)
        if (lowerValue.includes('registrada') || lowerValue.includes('vigente') || lowerValue.includes('concedida')) {
            colorClass = 'bg-emerald-100 text-emerald-800';
        } else if (lowerValue.includes('trámite') || lowerValue.includes('examen') || lowerValue.includes('contestación')) {
            colorClass = 'bg-blue-100 text-blue-800';
        } else if (lowerValue.includes('pendiente') || lowerValue.includes('vencer') || lowerValue.includes('por presentar')) {
            colorClass = 'bg-amber-100 text-amber-800';
        } else if (lowerValue.includes('vencida') || lowerValue.includes('cancelada') || lowerValue.includes('negada') || lowerValue.includes('abandonad')) {
            colorClass = 'bg-red-100 text-red-800';
        }
    }

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colorClass} ${className}`}>
            {type === 'impi' && displayValue
                ? displayValue
                    .replace(/registrada\s+/i, '')  // "Registrada Vigente" → "Vigente"
                    .replace(/\s+registrada/i, '')   // "Marca Registrada" → "Marca"
                    .trim()
                : displayValue}
        </span>
    );
};
